<template>
  <div class="part" v-for="part in writeParts" :key="part.id">
    <MemberPart :part="part"></MemberPart>
  </div>
</template>

<script>
import MemberPart from "@/components/MemberPart.vue";
export default {
  components: {
    MemberPart,
  },
  props: {
    members: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    writeParts() {
      const id = this.id;
      const member = this.members.find(t => t.id === id);
      const name = member.name;
      const parts = name.includes("+") ? name.split("+") : name.split(" ");

      return parts;
    },
  },
};
</script>

<style>
.member .name {
  display: flex;
  justify-content: center;
  margin-left: 2rem;
  width: calc(100% - 4rem);
}
.member .part {
    height: 3.7rem;
    display: flex;
    line-height: initial;
}
.member .part:not(:first-child) {
    margin-left: 1rem;
}
.member .part span, p .member {
    font-variation-settings: "SOFT" 100, "wght" 444, "WONK" 0, "opsz" 144;
    text-transform: uppercase;
    font-size: 3.4rem;
    letter-spacing: -0.2rem;
    text-shadow: 5px 3.5px #fff;
}
.member .part span:nth-child(2n + 1) {
    align-self: end;
}
p .member {
  font-size: inherit;
  line-height: 0.1;
  display: inline-block;
  width: auto;
  height: 1.75rem;
}
p .member .part {
  float: left;
  height: 2.75rem;
}
p .member .part:not(:first-child) {
    margin-left: .6rem;
}
p .member .part span {
  font-size: inherit;
}
p .member .part span:nth-child(2n + 2) {
  margin-top: .4rem;
}
.result .member {
  height: 2.5rem;
}
.result .member .part {
  height: 3.75rem;
}
.player .part span {
  text-shadow: 5px 3.5px var(--bg);
}
.member .part i {
  font-family: "Fraunces-Italic";
  align-self: center;
  font-size: 1.4rem;
  margin-left: .6rem;
}
.member select {
  background: initial;
  text-align: left;
}
</style>